import type { Category } from "@/types/content";

interface TopicFiltersProps {
  categories: Category[];
  activeCategory: string;
  onCategoryChange: (value: string) => void;
  statusOptions: string[];
  activeStatus: string;
  onStatusChange: (value: string) => void;
  sort: string;
  onSortChange: (value: string) => void;
  resultCount: number;
}

export default function TopicFilters({
  categories,
  activeCategory,
  onCategoryChange,
  statusOptions,
  activeStatus,
  onStatusChange,
  sort,
  onSortChange,
  resultCount,
}: TopicFiltersProps) {
  return (
    <div className="sticky top-16 z-30 border-b border-background-200 bg-background-50/95 backdrop-blur-sm md:top-[72px]">
      <div className="flex flex-col gap-3 px-4 py-4 md:px-8 lg:flex-row lg:items-center lg:justify-between">
        <div
          role="tablist"
          aria-label="话题分类"
          className="no-scrollbar -mx-1 flex items-center gap-1 overflow-x-auto px-1 py-1"
        >
          {categories.map((category) => {
            const active = category.id === activeCategory;
            return (
              <button
                key={category.id}
                type="button"
                role="tab"
                aria-selected={active}
                onClick={() => onCategoryChange(category.id)}
                className={`shrink-0 cursor-pointer whitespace-nowrap rounded-full px-4 py-2 text-sm font-medium transition-colors ${
                  active
                    ? "bg-primary-500 text-background-50"
                    : "text-foreground-700 hover:bg-background-100"
                }`}
              >
                {category.label}
              </button>
            );
          })}
        </div>

        <div className="flex flex-wrap items-center gap-2">
          <label className="sr-only" htmlFor="status-filter">
            按状态筛选
          </label>
          <select
            id="status-filter"
            value={activeStatus}
            onChange={(event) => onStatusChange(event.target.value)}
            className="h-10 cursor-pointer rounded-md border border-background-300 bg-background-50 px-3 text-sm text-foreground-800 focus:border-primary-400 focus:outline-none"
          >
            <option value="all">全部状态</option>
            {statusOptions.map((item) => (
              <option key={item} value={item}>
                {item}
              </option>
            ))}
          </select>

          <div className="flex items-center gap-1 rounded-md border border-background-300 bg-background-50 p-1">
            <button
              type="button"
              onClick={() => onSortChange("updated")}
              className={`cursor-pointer whitespace-nowrap rounded-full px-3 py-1.5 text-sm font-medium transition-colors ${
                sort === "updated"
                  ? "bg-foreground-950 text-background-50"
                  : "text-foreground-700 hover:bg-background-100"
              }`}
            >
              最近更新
            </button>
            <button
              type="button"
              onClick={() => onSortChange("heat")}
              className={`cursor-pointer whitespace-nowrap rounded-full px-3 py-1.5 text-sm font-medium transition-colors ${
                sort === "heat"
                  ? "bg-foreground-950 text-background-50"
                  : "text-foreground-700 hover:bg-background-100"
              }`}
            >
              按热度
            </button>
          </div>

          <span className="whitespace-nowrap text-sm text-foreground-500">
            共 {resultCount} 条
          </span>
        </div>
      </div>
    </div>
  );
}